type TeceoCrudFormConfig = {
  withPaper: boolean;
  disableButtonElevation: boolean;
};

const teceoCrudFormConfig: TeceoCrudFormConfig = {
  withPaper: false,
  disableButtonElevation: true,
};
export default teceoCrudFormConfig;
